// extracted by mini-css-extract-plugin
export var block1 = "betterHalva-module--block1--Tkr2x";
export var block2 = "betterHalva-module--block2--n78wY";
export var block3 = "betterHalva-module--block3--2YGSL";
export var grid = "betterHalva-module--grid--+-Ccc";
export var head = "betterHalva-module--head--N2LE7";
export var icon = "betterHalva-module--icon--R69Zt";
export var img = "betterHalva-module--img--+Rjf3";
export var section = "betterHalva-module--section--Hkisy";
export var title = "betterHalva-module--title--qGZxk";